<template lang="html">
  <span class="patient-goal" v-if="patGoal">
    <span class="patient-goal-label">Goal</span>
    <span class="patient-goal-value">{{ patGoal }}</span>
  </span>
</template>

<script>
export default {
  props: ['patGoal'],
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.patient-goal {
  display: inline-block;
  border-radius: 50px;
  height: 33px;
  overflow: hidden;
  line-height: 1em !important; // important as can get overridden sometimes

  .patient-goal-label,
  .patient-goal-value {
    padding: 8px 20px 10px;
    display: inline-block;
    height: 33px;
  }
  .patient-goal-label {
    background-color: @color-salmon;
    // image triangle on right edge
    padding-right: 40px;
    background-image: url('../assets/img/goal-pill-divider@2x.png');
    background-repeat: no-repeat;
    background-size: 40px 33px;
    background-position: right center;
  }
  .patient-goal-value {
    background-color: @color-green;
    font-weight: 700;
    padding-left: 0;
  }
}
</style>
